<template>
    <div class="bootbox modal video-player-modal" :style="{zIndex:zIndex}" v-show="player.show" transition="fade">
        <div class="modal-backdrop in"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="bootbox-close-button close" @click="player.show = false">
                        <i class="fa fa-close"></i>
                    </button>
                    <h4 class="modal-title">{{player.title}}</h4>
                </div>
                <div class="modal-body">
                    <!-- <div class="bootbox-body"></div> -->
                    <video data-role="video-player" class="video-js vjs-default-skin vjs-big-play-centered"
                            controls preload="auto"> <!--data-setup='{}'-->
                        <!--<source src="http://video-js.zencoder.com/oceans-clip.mp4" type="video/mp4" />
                        <source src="http://video-js.zencoder.com/oceans-clip.webm" type="video/webm" />
                        <source src="http://video-js.zencoder.com/oceans-clip.ogv" type="video/ogg" />-->
                        <p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="#" target="_blank">supports HTML5 video</a></p>
                    </video>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click.stop="ok()"> 确定 </button>
                </div> -->
            </div>
        </div>
    </div>
</template>
<style type="text/css">
    @import '../../node_modules/video.js/dist/video-js.css';

    .video-player-modal.modal .modal-dialog{
        width:900px;
    }
    .video-player-modal.modal .modal-header{
        border-bottom: 0;
        background: #333;
        padding: 10px;
    }
    .video-player-modal.modal .modal-title{
        color: #EEE;
        font-size: 16px;
        padding-left: 5px;
    }
    .video-player-modal.modal .modal-header .close{
        position: relative;
        top: 0px;
        padding: 0;
        width: 22px;
        height: 22px;
        text-indent: 0;
        color: #FFF;
        opacity: .8;
        background:none !important;
    }
    .video-player-modal.modal .modal-header .close i{
        color: #FFF;
        width: 14px;
        position: relative;
    }
    .video-player-modal.modal .modal-content{
        border: none;
    }
    .video-player-modal.modal .modal-body{
        padding: 0;
    }
</style>
<script type="text/javascript">

import $ from 'jquery';
import videojs from 'video.js';
//import '../../node_modules/video.js/dist/lang/zh-CN.js';

import { mapState, mapActions } from 'vuex';

export default {
    data(){
        return {
            zIndex: 0
        };
    },
    mounted(){
        this._player = videojs($(this.$el).find('[data-role="video-player"]')[0], {
            width: 900,
            language: 'zh-CN'
        }, function(){
          // Player (this) is initialized and ready.
        });
    },
    watch: {
        'player.src': function(val, old) {
            this._player && this._player.src(val/*[
                { type: "video/mp4", src: val },
                { type: "video/webm", src: "http://www.example.com/path/to/video.webm" },
                { type: "video/ogg", src: "http://www.example.com/path/to/video.ogv" }
            ]*/);
        },
        'player.poster': function(val, old){
            this._player && this._player.poster(val);
        },
        'player.show': function(val, oldVal){
            if(val === true) {
                this.zIndex = this.maxZIndex;
                this.increaseZIndex();

                if(this.player && this.player.autoPlay) {
                    this._player.play();
                }
            } else {
                this._player && this._player.pause();
            }
        }
    },
    computed: mapState([
        'player',
        'maxZIndex'
    ]),
    methods: {
        ...mapActions([
            'hidePlayer',
            'increaseZIndex'
        ])
    }
}
</script>
